var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Questions"},[_c('div',{staticClass:"container"},[_c('Topics'),_c('Dashboard'),_c('QuestionsList')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }